var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"live-teacher-player"}},[_c('div',{staticClass:"live-teacher-player-placeholder"})])}]

export { render, staticRenderFns }